// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import { NewPdfPart, type PdfPart, type PdfPartWireFormat } from '../PdfPart/PdfPart';
import { NewPlant, type Plant, type PlantWireFormat } from '../Plant/Plant';

export class PdfTemplate {
  readonly id: string;
  readonly type: Enums.PdfTemplateType;
  readonly template: string;
  readonly name: string;
  readonly position: number;
  readonly locations: Plant[];
  readonly parts: PdfPart[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.type = data.type === undefined ? Enums.PdfTemplateType.Code : data.type;
    this.template = data.template === undefined ? '' : data.template;
    this.name = data.name === undefined ? '' : data.name;
    this.position = data.position === undefined ? 0 : data.position;
    this.locations = (data.locations ?? []).map((locations: any) => NewPlant(locations));
    this.parts = (data.parts ?? []).map((parts: any) => NewPdfPart(parts));
  }

  static zero(): PdfTemplate {
    const zeroValues: ExcludeMethodsDeep<PdfTemplate> = {
      id: NIL_UUID,
      type: Enums.PdfTemplateType.Code,
      template: '',
      name: '',
      position: 0,
      locations: [],
      parts: [],
    };
    return new PdfTemplate(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PdfTemplateWireFormat = {
  id: string;
  type: string;
  template: string;
  name: string;
  position: number;
  locations: PlantWireFormat[];
  parts: PdfPartWireFormat[];
};

type NewPdfTemplateProps = PartialDeep<PdfTemplate, { recurseIntoArrays: true }>;
export const NewPdfTemplate: (props: NewPdfTemplateProps) => PdfTemplate = (props) =>
  new PdfTemplate(props);

type NewPdfTemplateFromWireFormatProps = PartialDeep<
  PdfTemplateWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPdfTemplateFromWireFormat: (
  props: NewPdfTemplateFromWireFormatProps,
) => PdfTemplate = (props) => new PdfTemplate(props);
